import double from './double'

/**
 * 将秒数格式化
 * @param { Number } seconds 秒数
 * @param { Number } type 类型 1: 0'0", 2: 00:00
 * @return { String } 格式化后的秒数
 */
export default (seconds, type = 1) => {
  const _totalSeconds = Math.floor(seconds)
  const _minutes = Math.floor(_totalSeconds / 60)
  const _seconds = _totalSeconds % 60
  switch (type) {
    case 1:
      return `${_minutes}'${_seconds}"`
    case 2:
      return `${double(_minutes)}:${double(_seconds)}`
  }
}
